<template>
	<div class="owl-carousel slider-navigation">
		<div class="item" v-for="item in items">
			<div class="containerItem2">
				<div class="top">
					<a class="img" :href="item.href" :lazy-background='item.img'>
						<!-- <img :src="item.img" alt=""> -->
					</a>
				</div>
				<div class="text">
					<a :href="item.href">
						<b>{{item.text}}</b>
					</a>
				</div>
				<div class="bottom">
					<div class="time">
						<span>
							<svg width="16px" height="16px">
								<use xlink:href="#svg-clock"></use>
							</svg>
						</span>
						<span>
							{{item.time}}
						</span>
					</div>
					<a :href="item.href" class="button waves-effect waves-light">
						{{item.button}}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 3 ? true : false,
				nav: true,
				dots: true,
				margin: 28,
				responsive: {
					0: {
						items: 1,
					},
					1024: {
						items: 2,
					},
					1180: {
						items: 3,
					}
				}
			}
		});
	},
	mounted() {
		lazyBackground();
	}
}
</script>

<style lang="scss" scope=".slider-lowCost">
@import "scss/wanted";

.slider-lowCost {
	/*margin-bottom: 85px;*/
		b{
			font-weight: 900;
		}
		.owl-carousel {
			position: relative;
			padding: 0 2px 70px 2px;
			.owl-stage-outer{
				// padding: 0 1px;
			}
			.item {
				.containerItem2{
					border: 1px solid #e2edf3;
					box-shadow: 0px 0px 2px #e2edf3;
					border-radius: 6px;
					margin: 1px;
					.img{
						width: 100%;
						height: 134px;
						border-radius: 5px 5px 0px 0px;
						background-position: center;
						background-size: cover;
						background-position: center;
						background-repeat: no-repeat;
						border-bottom: 1px solid #e2edf3;
            			// background-image: darkgrey;
					}
					.top{
						display: flex;
						justify-conent: center;
						align-items: center;
						overflow: hidden;
					}
					.text{
						padding-top: 26px;
						padding-left: 30px;
						padding-right: 30px;
						a{
							text-decoration: none;
							height: rem(42);
							overflow: hidden;
							display: block;
							&:hover{
								text-decoration: underline;
							}
						}
						b{
							color: black;
						}
					}
					.bottom{
						padding-bottom: 30px;
						display: flex;
						justify-content: space-between;
						&:after{
							content: "";
							width: 98%;
							position: absolute;
							top: -2px;
							left: 3px;
							right: 0;
							height: 2px;
							background: #fff;
						}
					}
					.time{
						margin-top: 23px;
						display: flex;
						align-items: center;
						margin-left: 30px;
						position: relative;
						font-size: rem(12);
						color: #444a4e;
						justify-content: space-between;
						span{
							&:nth-child(1){
								position: relative;
								top: 2px;
								bottom: 0;
							}
							&:nth-child(2){
								white-space: nowrap;
								margin-left: 10px;
							}
						}
					}
					.button{
						margin-right: 30px;
						margin-top: 23px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// lowCost.vue?52f16909